import { BaseHighchart } from '@/common/dashboard/charts/BaseHighchart';
import { Box, Typography } from '@mui/material';

/**
 * Renders the chart the chatbot's chart tool built for an answer. The backend produces the
 * Highcharts options, so this only sizes the frame: a horizontal bar chart grows with its bar
 * count, everything else keeps a compact fixed height.
 */
export const ChatbotChart = ({ chart }) => {
  const MIN_HEIGHT = 200;
  const MAX_HEIGHT = 420;
  const HEIGHT_PER_BAR = 26;

  const { title, chartType, pointCount, chartOptions } = chart;
  const height =
    chartType === 'bar' ? Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, pointCount * HEIGHT_PER_BAR + 40)) : MIN_HEIGHT;

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      {title && (
        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
          {title}
        </Typography>
      )}
      <Box sx={{ width: '100%', height }}>
        <BaseHighchart options={chartOptions} />
      </Box>
    </Box>
  );
};
